
import React from 'react';
import { TeamEditDialogWrapper } from './team-edit/TeamEditDialogWrapper';
import { TeamEditForm } from './team-edit/TeamEditForm';

interface Team {
  id: string;
  name: string;
  club_id: string;
  season_id: string | null;
  division_id?: string | null;
  birth_date_cutoff?: string | null;
  clubs?: {
    id: string;
    name: string;
    organizations?: {
      id: string;
      name: string;
    } | null;
  } | null;
}

interface TeamEditDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  team: Team;
  initialData: {
    name: string;
    division_id?: string;
    birth_date_cutoff?: string;
    profile_picture_url?: string;
  };
  isSubmitting: boolean;
  onSubmit: (data: {
    name: string;
    division_id?: string;
    birth_date_cutoff?: string;
    profile_picture_url?: string;
  }) => void;
  onClose: () => void;
}

export const TeamEditDialog = ({
  isOpen,
  onOpenChange,
  team,
  initialData,
  isSubmitting,
  onSubmit,
  onClose
}: TeamEditDialogProps) => {
  // Extract organization ID from team data
  const organizationId = team?.clubs?.organizations?.id;

  return (
    <TeamEditDialogWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <TeamEditForm
        initialData={initialData}
        isSubmitting={isSubmitting}
        onSubmit={onSubmit}
        onCancel={onClose}
        organizationId={organizationId}
      />
    </TeamEditDialogWrapper>
  );
};
